'use client';

import { useEffect, useRef, useState } from 'react';
import { Text } from '@mantine/core';

// KST용 포맷터(한 번만 생성)
const kstPartsFormatter = new Intl.DateTimeFormat('ko-KR', {
  timeZone: 'Asia/Seoul',
  hour12: false,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
});

function formatKSTFixed(d: Date) {
  const parts = kstPartsFormatter.formatToParts(d);
  const get = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((p) => p.type === type)?.value ?? '';

  const y = get('year');   // 4자리 보장
  const M = get('month');  // 2자리 보장
  const D = get('day');    // 2자리 보장
  const h = get('hour');   // 2자리 보장
  const m = get('minute'); // 2자리 보장
  const s = get('second'); // 2자리 보장

  // 항상 동일한 형식으로 출력
  return `${y}년 ${M}월 ${D}일 ${h}:${m}:${s}`;
}

export default function KoreanClock() {
  const [time, setTime] = useState(() => formatKSTFixed(new Date()));
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const runningRef = useRef(true);

  useEffect(() => {
    const tick = () => {
      if (!runningRef.current) return;
      setTime(formatKSTFixed(new Date()));

      // 다음 초 경계까지 보정
      const now = Date.now();
      const delay = 1000 - (now % 1000);
      timerRef.current = setTimeout(tick, delay);
    };

    const onVisibility = () => {
      const visible = document.visibilityState === 'visible';
      runningRef.current = visible;
      clearTimeout(timerRef.current as any);
      if (visible) {
        setTime(formatKSTFixed(new Date()));
        const now = Date.now();
        const delay = 1000 - (now % 1000);
        timerRef.current = setTimeout(tick, delay);
      }
    };

    document.addEventListener('visibilitychange', onVisibility);
    onVisibility();

    return () => {
      document.removeEventListener('visibilitychange', onVisibility);
      clearTimeout(timerRef.current as any);
    };
  }, []);

  return <Text fw={700} fz={'1.25rem'}>{time}</Text>;
}
